// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-phases{}

.tournament-phases__phases{}

.tournament-phases__phases__arrow{
    display: flex;
    align-items: center;
    margin: var( --space-x2 ) 0;
}

.tournament-phases__phases__arrow .icon-arrow-left {
    font-size: var(--space-and-half);
    cursor: pointer;
    margin-right: calc( var( --space-and-half ) + var( --space-quarter ) );
    color: var(--primary-dark-color) !important;
}

.color-text{
    color: var(--primary-dark-color) !important;
}

/* .tournament-phases__phases__content,
.tournament-phases__phases__arrow.title {
    margin: 0 var(--space-x3); 
    display: grid;
    grid-template-areas: "left left center center center center center center center center right right";
    grid-template-columns: repeat(12, 1fr); 
    grid-gap: var(--space-and-half);
    gap: var(--space-and-half); 
    padding-bottom: var(--space-x3);
}  */

.tournament-phases__type{
    padding-bottom: var(--space-x3);    
}

.grops-description {
    margin-bottom: calc(var(--space-and-half) + 5px);
}

.grops-description p{
    margin-bottom: var(--space-and-half);
}

.grops-description__color {
    color: var(--primary-very-dark-color);
}

.tournament-phases-groups-continue-button {
    padding-top: calc(var(--space) * 2);    
    float: right;
}

.tournament-phases__phases__content__add.phase-types,
.tournament-phases__phases__arrow.title .tournament-phases__phases__arrow_content_text {
    grid-column-start: 5;
    grid-column-end: 9;
    margin-left: -2%
}

.tournament-phases__container {
    /* display: flex; */
}

.add-phase.baloa-table-column{
    color: var( --white-color );
    padding: var( --space-half ) var( --space-x3 );    
    margin-bottom: var( --space-and-half );
}

/* .tournament-phases__phases__content-container.initial-phase {
    grid-area: center;
} */

.tournament-phases__phases__arrow_content_text p {
    margin-bottom: var(--space);
}

.tournament-phases__phases__arrow_content_text .baloa-names{
    color: var(--primary-very-dark-color);
}

.tournament-phases__container_phases-created{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

.tournament-phases-information_options-box.active {
    display: flex;
    flex-direction: column;
}

.tournament-phases-information_options-box {
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgba(150 150 150 / 25%);
    width: 200px;
    display: none;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    padding: 8px;
    top: var(--space-x2);
}

.tournament-phases-information_options-box__option{
    border-radius: 8px;
    padding: 8px;
    display: flex;
    align-items: center;
    gap: var(--space-half);
}

.tournament-phases-information_options-box__option .hubicon-edit::before{
    color: var(--primary-very-dark-color);
    font-size: 20px;
}

.tournament-phases-information_options-box__option .hubicon-delete_question::before{
    color: var(--primary-very-dark-color);
    font-size: 20px;
}

.tournament-phases-information_options-box__option:hover{
    background-color: var(--new-background-color);
}

.league-tournament-report__phases__list.tournament-phases{
    background-color: var(--white-color);
    display: flex;
    align-items: center;
    flex-direction: row;
}

.league-tournament-report__phases__list.tournament-phases .icon-options {
    font-size: 18px;
    border-radius: 50%;
    padding: var(--space-half);
    background: var(--new-background-color);
}

.tournament-phases__phases__arrow.label_title{
    padding-left: 13%;
    margin-bottom: var(--space-x2);
}

.tournament-phases__container_show_phases{
    display:flex;
    margin: var(--space) 0;
}

.grops-description_phases_review{
    margin-bottom: var(--space);
}

.grops-description_phases_review_sub_title{
    margin: var(--space) 0;
}

.tournament-phases__content_reviewPhase_button{
    display: grid;
    justify-content: end;
}

.tournament-phases__phase-options__container {
    position: relative;
}

.tournament-phases__phase-options__container:hover {
    cursor: pointer;
    
}

.tournament-phases__container-tab-calendar-add-teams_Phase{
    display: flex;
    align-content: center;
    align-items: center;
    background: #FFFFFF;
    border: 1px solid #E7E7E7;
    border-radius: 8px;
    width: 70%;
    justify-content: space-between;
    padding: var(--space);
    margin: var(--space-and-half) 0;
}

.tournament-phases__container-tab-calendar-add-team_text{
    display: flex;
    gap: var(--space-half);
    align-items: center;
}

.tournament-phases__container-tab-calendar-add-teams_phase_button{
    text-transform: initial;
}

.grops-description_phases_review_button{
    display: grid;
    justify-content: end;
}

.tournament-phases__finish-current-phase {
    position: relative;
}

.tournament-phases__finish-current-phase__tooltip .baloa-table-column {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
}

.tournament-phases__finish-current-phase__tooltip {
    position: absolute;
    padding: var(--space-half-quarter);
    background-color: var(--white-color);
    border-radius: var(--space-half);
    border: 1px solid var(--new-gray-background-color);
    bottom: 64px;
    width: 230px;
    box-shadow: var(--shadow-card);
    display: none;
}

.tournament-phases__finish-current-phase__tooltip::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    margin-left: -15px;
    bottom: -20px;
    left: 50%;
    box-sizing: border-box;
    border: 10px solid var(--new-gray-background-color);
    border-color: transparent transparent var(--white-color) var(--white-color);
    transform-origin: 0 0;
    transform: rotate(-45deg);
    box-shadow: -1px 1px 1px 0 rgb(0 0 0 / 25%);
}

.tournament-phases__finish-current-phase:hover .tournament-phases__finish-current-phase__tooltip {
    display: block;
}

.tournament-phases__action-btns {
    display: flex;
    align-items: center;
}

.tournament-phases__action-btns .button {
    padding: var(--space-half) var(--space);
    font-size: calc( var(--space) + 1);
    line-height: calc( var(--space) + var(--space-quarter) );
    align-items: center;
}

.tournament-phases__finish-current-phase .secondary-button {
    margin-right: var(--space-half-quarter);
}

.tournament-phases__action-btns .button span {
    font-size: calc( var(--space) + 1);
    line-height: calc( var(--space) + var(--space-quarter) );
}

.tournament-phases__no-phases__container {
    display: flex;
    align-content: center;
    align-items: center;
    background: var(--new-informative-banner-bg-color);
    border-radius: var(--space-half);   
    justify-content: space-between;
    padding: var(--space-half-quarter);
    margin-top: var(--space-and-half);
    border-left: var(--space-half) solid var(--new-informative-banner-color);
}

.tournament-phases__no-phases {
    display: flex;
    align-items: center;
    gap: var(--space);
}

.tournament-phases__no-phases .hubicon-info {
    font-size: var(--space);
}

.tournament-phases__no-phases .hubicon-info::before {
    color: var(--new-informative-banner-color);
}

.tournament-phases__no-phases__container .primary-button {
    padding: calc( var(--space-half) + var(--space-eighth) ) calc( var(--space) + var(--space-quarter) );
    font-size: calc(var(--space) + 1px);
    line-height: calc(var(--space) + var(--space-quarter));
}

.tournament-phases__add-teams__container {
    display: flex;
    align-content: center;
    align-items: center;
    background: var(--new-informative-banner-bg-color);
    border-radius: var(--space-half);   
    justify-content: space-between;
    padding: var(--space-half-quarter);
    margin-top: var(--space-and-half);
    border-left: var(--space-half) solid var(--new-informative-banner-color);
}

.tournament-phases__add-team__text {
    display: flex;
    gap: var(--space);
    align-items: center;
}

.tournament-phases__add-team__text .hubicon-info {
    font-size: var(--space);
}

.tournament-phases__add-team__text .hubicon-info::before {
    color: var(--new-informative-banner-color);
}

.tournament-phases__add-teams__phase-button{
    text-transform: initial;
    padding: calc( var(--space-half) + var(--space-eighth) ) calc( var(--space) + var(--space-quarter) );
    font-size: calc(var(--space) + 1px);
    line-height: calc(var(--space) + var(--space-quarter));
    display: flex;
    align-items: center;
    gap: var(--space-half-quarter);
}

.tournament-phases__add-teams__phase-button .hubicon-low_priority{
    font-size: calc(var(--space) + var(--space-quarter));
}

.tournament-phases__add-teams__phase-button .hubicon-low_priority::before{
    color: var(--white-color);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-phases/TournamentPhasesComponent.styles.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB,2BAA2B;;AAE3B;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,sEAAsE;IACtE,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;;;;;;;;IASI;;AAEJ;IACI,+BAA+B;AACnC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mCAAmC;IACnC,YAAY;AAChB;;AAEA;;IAEI,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,sCAAsC;AAC1C;;AAEA;;GAEG;;AAEH;IACI,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,+CAA+C;IAC/C,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kDAAkD;IAClD,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,8BAA8B;IAC9B,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,oCAAoC;IACpC,gCAAgC;IAChC,kDAAkD;IAClD,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,mDAAmD;IACnD,2EAA2E;IAC3E,qBAAqB;IACrB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,kCAAkC;IAClC,wDAAwD;IACxD,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kCAAkC;IAClC,wDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,kDAAkD;IAClD,gCAAgC;IAChC,8BAA8B;IAC9B,kCAAkC;IAClC,iCAAiC;IACjC,wEAAwE;AAC5E;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,oGAAoG;IACpG,mCAAmC;IACnC,sDAAsD;AAC1D;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,kDAAkD;IAClD,gCAAgC;IAChC,8BAA8B;IAC9B,kCAAkC;IAClC,iCAAiC;IACjC,wEAAwE;AAC5E;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;IACvB,oGAAoG;IACpG,mCAAmC;IACnC,sDAAsD;IACtD,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".tournament-phases{}\n\n.tournament-phases__phases{}\n\n.tournament-phases__phases__arrow{\n    display: flex;\n    align-items: center;\n    margin: var( --space-x2 ) 0;\n}\n\n.tournament-phases__phases__arrow .icon-arrow-left {\n    font-size: var(--space-and-half);\n    cursor: pointer;\n    margin-right: calc( var( --space-and-half ) + var( --space-quarter ) );\n    color: var(--primary-dark-color) !important;\n}\n\n.color-text{\n    color: var(--primary-dark-color) !important;\n}\n\n/* .tournament-phases__phases__content,\n.tournament-phases__phases__arrow.title {\n    margin: 0 var(--space-x3); \n    display: grid;\n    grid-template-areas: \"left left center center center center center center center center right right\";\n    grid-template-columns: repeat(12, 1fr); \n    grid-gap: var(--space-and-half);\n    gap: var(--space-and-half); \n    padding-bottom: var(--space-x3);\n}  */\n\n.tournament-phases__type{\n    padding-bottom: var(--space-x3);    \n}\n\n.grops-description {\n    margin-bottom: calc(var(--space-and-half) + 5px);\n}\n\n.grops-description p{\n    margin-bottom: var(--space-and-half);\n}\n\n.grops-description__color {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-phases-groups-continue-button {\n    padding-top: calc(var(--space) * 2);    \n    float: right;\n}\n\n.tournament-phases__phases__content__add.phase-types,\n.tournament-phases__phases__arrow.title .tournament-phases__phases__arrow_content_text {\n    grid-column-start: 5;\n    grid-column-end: 9;\n    margin-left: -2%\n}\n\n.tournament-phases__container {\n    /* display: flex; */\n}\n\n.add-phase.baloa-table-column{\n    color: var( --white-color );\n    padding: var( --space-half ) var( --space-x3 );    \n    margin-bottom: var( --space-and-half );\n}\n\n/* .tournament-phases__phases__content-container.initial-phase {\n    grid-area: center;\n} */\n\n.tournament-phases__phases__arrow_content_text p {\n    margin-bottom: var(--space);\n}\n\n.tournament-phases__phases__arrow_content_text .baloa-names{\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-phases__container_phases-created{\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.tournament-phases-information_options-box.active {\n    display: flex;\n    flex-direction: column;\n}\n\n.tournament-phases-information_options-box {\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgba(150 150 150 / 25%);\n    width: 200px;\n    display: none;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    padding: 8px;\n    top: var(--space-x2);\n}\n\n.tournament-phases-information_options-box__option{\n    border-radius: 8px;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    gap: var(--space-half);\n}\n\n.tournament-phases-information_options-box__option .hubicon-edit::before{\n    color: var(--primary-very-dark-color);\n    font-size: 20px;\n}\n\n.tournament-phases-information_options-box__option .hubicon-delete_question::before{\n    color: var(--primary-very-dark-color);\n    font-size: 20px;\n}\n\n.tournament-phases-information_options-box__option:hover{\n    background-color: var(--new-background-color);\n}\n\n.league-tournament-report__phases__list.tournament-phases{\n    background-color: var(--white-color);\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n}\n\n.league-tournament-report__phases__list.tournament-phases .icon-options {\n    font-size: 18px;\n    border-radius: 50%;\n    padding: var(--space-half);\n    background: var(--new-background-color);\n}\n\n.tournament-phases__phases__arrow.label_title{\n    padding-left: 13%;\n    margin-bottom: var(--space-x2);\n}\n\n.tournament-phases__container_show_phases{\n    display:flex;\n    margin: var(--space) 0;\n}\n\n.grops-description_phases_review{\n    margin-bottom: var(--space);\n}\n\n.grops-description_phases_review_sub_title{\n    margin: var(--space) 0;\n}\n\n.tournament-phases__content_reviewPhase_button{\n    display: grid;\n    justify-content: end;\n}\n\n.tournament-phases__phase-options__container {\n    position: relative;\n}\n\n.tournament-phases__phase-options__container:hover {\n    cursor: pointer;\n    \n}\n\n.tournament-phases__container-tab-calendar-add-teams_Phase{\n    display: flex;\n    align-content: center;\n    align-items: center;\n    background: #FFFFFF;\n    border: 1px solid #E7E7E7;\n    border-radius: 8px;\n    width: 70%;\n    justify-content: space-between;\n    padding: var(--space);\n    margin: var(--space-and-half) 0;\n}\n\n.tournament-phases__container-tab-calendar-add-team_text{\n    display: flex;\n    gap: var(--space-half);\n    align-items: center;\n}\n\n.tournament-phases__container-tab-calendar-add-teams_phase_button{\n    text-transform: initial;\n}\n\n.grops-description_phases_review_button{\n    display: grid;\n    justify-content: end;\n}\n\n.tournament-phases__finish-current-phase {\n    position: relative;\n}\n\n.tournament-phases__finish-current-phase__tooltip .baloa-table-column {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n}\n\n.tournament-phases__finish-current-phase__tooltip {\n    position: absolute;\n    padding: var(--space-half-quarter);\n    background-color: var(--white-color);\n    border-radius: var(--space-half);\n    border: 1px solid var(--new-gray-background-color);\n    bottom: 64px;\n    width: 230px;\n    box-shadow: var(--shadow-card);\n    display: none;\n}\n\n.tournament-phases__finish-current-phase__tooltip::after {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 0;\n    margin-left: -15px;\n    bottom: -20px;\n    left: 50%;\n    box-sizing: border-box;\n    border: 10px solid var(--new-gray-background-color);\n    border-color: transparent transparent var(--white-color) var(--white-color);\n    transform-origin: 0 0;\n    transform: rotate(-45deg);\n    box-shadow: -1px 1px 1px 0 rgb(0 0 0 / 25%);\n}\n\n.tournament-phases__finish-current-phase:hover .tournament-phases__finish-current-phase__tooltip {\n    display: block;\n}\n\n.tournament-phases__action-btns {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-phases__action-btns .button {\n    padding: var(--space-half) var(--space);\n    font-size: calc( var(--space) + 1);\n    line-height: calc( var(--space) + var(--space-quarter) );\n    align-items: center;\n}\n\n.tournament-phases__finish-current-phase .secondary-button {\n    margin-right: var(--space-half-quarter);\n}\n\n.tournament-phases__action-btns .button span {\n    font-size: calc( var(--space) + 1);\n    line-height: calc( var(--space) + var(--space-quarter) );\n}\n\n.tournament-phases__no-phases__container {\n    display: flex;\n    align-content: center;\n    align-items: center;\n    background: var(--new-informative-banner-bg-color);\n    border-radius: var(--space-half);   \n    justify-content: space-between;\n    padding: var(--space-half-quarter);\n    margin-top: var(--space-and-half);\n    border-left: var(--space-half) solid var(--new-informative-banner-color);\n}\n\n.tournament-phases__no-phases {\n    display: flex;\n    align-items: center;\n    gap: var(--space);\n}\n\n.tournament-phases__no-phases .hubicon-info {\n    font-size: var(--space);\n}\n\n.tournament-phases__no-phases .hubicon-info::before {\n    color: var(--new-informative-banner-color);\n}\n\n.tournament-phases__no-phases__container .primary-button {\n    padding: calc( var(--space-half) + var(--space-eighth) ) calc( var(--space) + var(--space-quarter) );\n    font-size: calc(var(--space) + 1px);\n    line-height: calc(var(--space) + var(--space-quarter));\n}\n\n.tournament-phases__add-teams__container {\n    display: flex;\n    align-content: center;\n    align-items: center;\n    background: var(--new-informative-banner-bg-color);\n    border-radius: var(--space-half);   \n    justify-content: space-between;\n    padding: var(--space-half-quarter);\n    margin-top: var(--space-and-half);\n    border-left: var(--space-half) solid var(--new-informative-banner-color);\n}\n\n.tournament-phases__add-team__text {\n    display: flex;\n    gap: var(--space);\n    align-items: center;\n}\n\n.tournament-phases__add-team__text .hubicon-info {\n    font-size: var(--space);\n}\n\n.tournament-phases__add-team__text .hubicon-info::before {\n    color: var(--new-informative-banner-color);\n}\n\n.tournament-phases__add-teams__phase-button{\n    text-transform: initial;\n    padding: calc( var(--space-half) + var(--space-eighth) ) calc( var(--space) + var(--space-quarter) );\n    font-size: calc(var(--space) + 1px);\n    line-height: calc(var(--space) + var(--space-quarter));\n    display: flex;\n    align-items: center;\n    gap: var(--space-half-quarter);\n}\n\n.tournament-phases__add-teams__phase-button .hubicon-low_priority{\n    font-size: calc(var(--space) + var(--space-quarter));\n}\n\n.tournament-phases__add-teams__phase-button .hubicon-low_priority::before{\n    color: var(--white-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
